import { createProductIcon } from './product-icon.js';
import { createInterfaceIcon } from './interface-icon.js';

/** Tablet/mobile current app and separate rightmost catalog switcher. */
export function createCompactNavigation(document) {
  const node = (tag, name) => {
    const element = document.createElement(tag);
    element.className = `positive-nav-compact${name ? `-${name}`: ''}`;
    return element;
  };
  const button = (name, source) => {
    const element = node('button', name);
    element.classList.add('positive-nav-button');
    element.type = 'button';
    element.dataset.action = 'openCatalog';
    element.dataset.source = source;
    return element;
  };
  const element = node('div');
  const current = node('span', 'current');
  const icon = node('span', 'icon');
  const name = node('span', 'name');
  current.append(icon, name);
  const others = button('others', 'allProducts');
  const stack = node('span', 'stack');
  stack.setAttribute('aria-hidden', 'true');
  const count = node('span', 'count');
  count.setAttribute('aria-hidden', 'true');
  others.append(stack, count);
  element.append(current);
  const marks = new Map();
  let currentId;

  return {
    element, current, others,
    update(catalog, t) {
      const product = catalog.currentProduct;
      if (currentId !== (product?.id ?? null)) {
        icon.replaceChildren(product ? createProductIcon(product.logoId, document): createInterfaceIcon('apps', document));
        currentId = product?.id ?? null;
      }
      name.textContent = product?.name ?? t('nav.brandProducts');
      current.setAttribute('aria-label', product
        ? t('nav.currentProduct', { product: product.name })
       : t('nav.brandProducts'));
      if (product) current.setAttribute('aria-current', 'page');
      else current.removeAttribute('aria-current');
      others.setAttribute('aria-label', `${t('nav.allProducts')} · ${t('nav.otherProducts', { count: catalog.counts.other })}`);
      count.textContent = `+${catalog.counts.other}`;
      others.hidden = catalog.counts.other === 0;
      const products = catalog.visibleProducts.filter(({ isCurrent }) => !isCurrent).slice(0, 3);
      const visible = new Set(products.map(({ id }) => id));
      for (const [id, mark] of marks) if (!visible.has(id)) { mark.remove(); marks.delete(id); }
      products.forEach((product, index) => {
        let mark = marks.get(product.id);
        if (!mark) {
          mark = node('span', 'mark');
          mark.append(createProductIcon(product.logoId, document));
          marks.set(product.id, mark);
        }
        if (stack.children[index] !== mark) stack.insertBefore(mark, stack.children[index] ?? null);
      });
    },
    dispose() {
      marks.clear();
      icon.replaceChildren();
      stack.replaceChildren();
      element.replaceChildren();
    },
  };
}
